import { useQuery } from '@tanstack/react-query'
import { getStats, getHealth } from '../api/stats'

/**
 * Hook to fetch dashboard statistics.
 */
export function useStats() {
  return useQuery({
    queryKey: ['dashboard-stats'],
    queryFn: getStats,
    staleTime: 1000 * 60 * 2, // 2 minutes - stats change moderately
    refetchInterval: 1000 * 60 * 2, // Auto-refresh every 2 minutes
  })
}

/**
 * Hook to fetch system health status.
 * Polls every 30 seconds to keep health indicators current.
 */
export function useHealth() {
  return useQuery({
    queryKey: ['system-health'],
    queryFn: getHealth,
    staleTime: 1000 * 30, // 30 seconds
    refetchInterval: 1000 * 30, // Poll every 30 seconds
  })
}
